import PDFViewer from "./PdfViewer";
import Video from "./Video";
import TextFile from "./TextFile";
import Browser from "./Browser";
import Image from "./Image";
import SubmitCtf from "./SubmitCtf";
import SubmitCtf_2 from "./SubmitCtf_2";
import MorseConverter from "./MorseConverter";
import Calculator from "./Calculator";

//Files Icons
import FileIcon from "./Icons/PNG/file.png";
import BrowserIcon from "./Icons/PNG/browser.png";
import FolderIcon from "./Icons/PNG/folder.png";
import VideoIcon from "./Icons/PNG/video.png";
import PdfIcon from "./Icons/PNG/pdf.png";
import ImageIcon from "./Icons/PNG/image.png";
import MusicIcon from "./Icons/PNG/music.png";
import CTFIcon from "./Icons/PNG/ctf.png";
import Morseicon from "./Icons/PNG/morse_code.png";
import LinkedIn from "./Icons/linkedin.png";
import CalculatorIcon from "./Icons/PNG/calculator.png";

//Icons but SVG
import FileIcon_svg from "./Icons/SVG/file.svg";
import BrowserIcon_svg from "./Icons/SVG/browser.svg";
import FolderIcon_svg from "./Icons/SVG/folder.svg";
import VideoIcon_svg from "./Icons/SVG/video.svg";
import PdfIcon_svg from "./Icons/SVG/pdf.svg";
import ImageIcon_svg from "./Icons/SVG/image.svg";
import MusicIcon_svg from "./Icons/SVG/music.svg";
import CTFIcon_svg from "./Icons/SVG/ctf.svg";
import Morseicon_svg from "./Icons/SVG/morse_code.svg";
import CalculatorIcon_svg from "./Icons/SVG/calculator.svg";
//Video files
import video_file_source from "./Videos/why_not.mp4";

//Pdf files
import pdf_cv from "./Pdfs/CV_Ali_Bouta.pdf";
import pdf_thesis from "./Pdfs/Masters_Thesis.pdf";
import recommendation_letter_1 from "./Pdfs/Recommendation_Letter_1.pdf";
import recommendation_letter_2 from "./Pdfs/Recommendation_Letter_2.pdf";
import recommendation_letter_3 from "./Pdfs/Recommendation_Letter_3.pdf";

//images
import meme_1 from "./memes/meme-1.png";
import meme_2 from "./memes/meme-2.jpg";
import meme_3 from "./memes/meme-3.jpg";
import tupsu_1 from "./catpics/tupsu1.jpeg";
import tupsu_2 from "./catpics/tupsu2.jpeg";
import tupsu_3 from "./catpics/tupsu3.jpeg";
import kiisumau1 from "./catpics/kiisumau1.jpeg";
import kiisumau2 from "./catpics/kiisumau2.jpeg";
import kiisumau3 from "./catpics/kiisumau3.jpeg";
import kiisumau4 from "./catpics/kiisumau4.jpeg";
import kiisumau5 from "./catpics/kiisumau5.jpeg";
import kiisumau6 from "./catpics/kiisumau6.jpeg";
import kiisumau7 from "./catpics/kiisumau7.jpeg";
import tupsu_and_kiisumau1 from "./catpics/tupsu_and_kiisumau1.jpeg";

//Songs
import Music_1 from "./Music/UP.mp3";
import Music_2 from "./Music/Coolio - Gangsta's Paradise.mp3";

export const AllIcons = [
  {
    id: "1",
    file_name: "Notes.txt",
    file_type: "tf", //text file
    icon_source: FileIcon,
    content: (
      <TextFile content="//TODO:\n-Fix moving files out of folders + fix other errors (like folder inside itself)\n-Add possibility to open multiple window of the same app\n-add possibility to create new files\n-Fix some bugs\n" />
    ),
    gridPosition: { x: 0, y: 0 },
    parentFolder: null, // null means it's on the desktop
  },
  {
    id: "2",
    file_name: "Browser",
    file_type: "b", //browser
    icon_source: BrowserIcon,
    content: (
      <Browser
        initialUrl="https://satisfyingclock.netlify.app"
        theme="dark"
        customBookmarks={[
          { name: "React Docs", url: "https://react.dev" },
          { name: "My Portfolio", url: "https://ali-bouta.netlify.app" },
        ]}
        onUrlChange={(url) => console.log("Navigated to:", url)}
      />
    ),
    gridPosition: { x: 1, y: 0 },
    parentFolder: "9",
  },
  {
    id: "3",
    file_name: "Documents",
    file_type: "d", //directory
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 2, y: 0 },
    parentFolder: null,
  },
  /*{ add later
      id: "4",
      file_name: "Terminal",
      file_type: "t", //terminal
      icon_source: TerminalIcon,
      content: null,
      gridPosition: { x: 0, y: 1 },
      parentFolder: null,
    },*/
  {
    id: "5",
    file_name: "Why_should_you_hire_me.mp4",
    file_type: "v", //video
    icon_source: VideoIcon,
    content: <Video src={video_file_source} width="100%" height="100%" />,
    gridPosition: { x: 6, y: 0 },
    parentFolder: null,
  },
  {
    id: "6",
    file_name: "My_CV.pdf",
    file_type: "p", //PDF File
    icon_source: PdfIcon,
    content: (
      <PDFViewer
        pdfUrl={pdf_cv}
        fileName="My_CV.pdf"
        theme="light"
        enableToolbar={true}
        enableSearch={true}
        enableDownload={true}
        enablePrint={true}
        onDocumentLoad={(info) => console.log("PDF loaded:", info)}
        onPageChange={(page) => console.log("Page changed:", page)}
        onZoomChange={(zoom) => console.log("Zoom changed:", zoom)}
        customToolbarButtons={[
          {
            label: "Custom",
            icon: "⚙️",
            title: "Custom Action",
            onClick: () => alert("Custom button clicked!"),
          },
        ]}
      />
    ),
    gridPosition: { x: 5, y: 0 },
    parentFolder: null,
  },
  {
    id: "7",
    file_name: "readme.txt",
    file_type: "tf",
    icon_source: FileIcon,
    content: (
      <TextFile content="This is a readme file inside the Documents folder\nIt has no useful information whatsoever\n" />
    ),
    gridPosition: { x: 0, y: 0 },
    parentFolder: "3", // Inside Documents folder
  },
  {
    id: "8",
    file_name: "Subfolder",
    file_type: "d",
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 1, y: 0 },
    parentFolder: "3", // Inside Documents folder
  },
  {
    id: "9",
    file_name: "My Projects",
    file_type: "d",
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 1, y: 0 },
    parentFolder: null,
  },
  {
    id: "10",
    file_name: "readme.txt",
    file_type: "tf",
    icon_source: FileIcon,
    content: (
      <TextFile content="The browser has a website I built many years ago to act as a screensaver which has different themes and satisfying background sounds.\n" />
    ),
    gridPosition: { x: 0, y: 0 },
    parentFolder: "9",
  },
  {
    id: "11",
    file_name: "Pictures",
    file_type: "d",
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 3, y: 0 },
    parentFolder: null,
  },
  {
    id: "12",
    file_name: "Memes",
    file_type: "d",
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 1, y: 0 },
    parentFolder: "11",
  },
  {
    id: "13",
    file_name: "Cat Pics",
    file_type: "d",
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 0, y: 0 },
    parentFolder: "11",
  },
  {
    id: "14",
    file_name: "meme-1.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: meme_1,
    alt: "Meme",
    content: null,
    gridPosition: { x: 0, y: 0 },
    parentFolder: "12",
  },
  {
    id: "15",
    file_name: "meme-2.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: meme_2,
    alt: "Meme",
    content: null,
    gridPosition: { x: 1, y: 0 },
    parentFolder: "12",
  },
  {
    id: "16",
    file_name: "meme-3.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: meme_3,
    alt: "Meme",
    content: null,
    gridPosition: { x: 2, y: 0 },
    parentFolder: "12",
  },
  {
    id: "17",
    file_name: "tupsu_and_kiisumau1.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: tupsu_and_kiisumau1,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 3, y: 0 },
    parentFolder: "13",
  },
  {
    id: "18",
    file_name: "tupsu_1.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: tupsu_1,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 0, y: 0 },
    parentFolder: "13",
  },

  {
    id: "19",
    file_name: "tupsu_2.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: tupsu_2,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 1, y: 0 },
    parentFolder: "13",
  },

  {
    id: "20",
    file_name: "tupsu_3.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: tupsu_3,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 2, y: 0 },
    parentFolder: "13",
  },

  {
    id: "21",
    file_name: "kiisumau1.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: kiisumau1,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 4, y: 0 },
    parentFolder: "13",
  },

  {
    id: "22",
    file_name: "kiisumau2.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: kiisumau2,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 5, y: 0 },
    parentFolder: "13",
  },

  {
    id: "23",
    file_name: "kiisumau3.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: kiisumau3,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 0, y: 1 },
    parentFolder: "13",
  },

  {
    id: "24",
    file_name: "kiisumau4.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: kiisumau4,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 1, y: 1 },
    parentFolder: "13",
  },
  {
    id: "25",
    file_name: "kiisumau5.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: kiisumau5,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 2, y: 1 },
    parentFolder: "13",
  },
  {
    id: "26",
    file_name: "kiisumau6.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: kiisumau6,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 3, y: 1 },
    parentFolder: "13",
  },
  {
    id: "27",
    file_name: "kiisumau7.jpg",
    file_type: "i",
    icon_source: ImageIcon,
    src: kiisumau7,
    alt: "Cat Picture",
    content: null,
    gridPosition: { x: 4, y: 1 },
    parentFolder: "13",
  },
  {
    id: "28",
    file_name: "Masters_Thesis.pdf",
    file_type: "p",
    icon_source: PdfIcon,
    content: (
      <PDFViewer
        pdfUrl={pdf_thesis}
        fileName="Masters_Thesis.pdf"
        theme="light"
        enableToolbar={true}
        enableSearch={true}
        enableDownload={true}
        enablePrint={true}
        onDocumentLoad={(info) => console.log("PDF loaded:", info)}
        onPageChange={(page) => console.log("Page changed:", page)}
        onZoomChange={(zoom) => console.log("Zoom changed:", zoom)}
        customToolbarButtons={[
          {
            label: "Custom",
            icon: "⚙️",
            title: "Custom Action",
            onClick: () => alert("Custom button clicked!"),
          },
        ]}
      />
    ),
    gridPosition: { x: 2, y: 1 },
    parentFolder: null,
  },
  {
    id: "29",
    file_name: "Recommendation Letters",
    file_type: "d",
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 3, y: 1 },
    parentFolder: null,
  },
  {
    id: "30",
    file_name: "Recommendation_Letter_1.pdf",
    file_type: "p",
    icon_source: PdfIcon,
    content: (
      <PDFViewer
        pdfUrl={recommendation_letter_1}
        fileName="Recommendation_Letter_1.pdf"
        theme="light"
        enableToolbar={true}
        enableSearch={true}
        enableDownload={true}
        enablePrint={true}
        onDocumentLoad={(info) => console.log("PDF loaded:", info)}
        onPageChange={(page) => console.log("Page changed:", page)}
        onZoomChange={(zoom) => console.log("Zoom changed:", zoom)}
        customToolbarButtons={[
          {
            label: "Custom",
            icon: "⚙️",
            title: "Custom Action",
            onClick: () => alert("Custom button clicked!"),
          },
        ]}
      />
    ),
    gridPosition: { x: 0, y: 0 },
    parentFolder: "29",
  },
  {
    id: "31",
    file_name: "Recommendation_Letter_2.pdf",
    file_type: "p",
    icon_source: PdfIcon,
    content: (
      <PDFViewer
        pdfUrl={recommendation_letter_2}
        fileName="Recommendation_Letter_2.pdf"
        theme="light"
        enableToolbar={true}
        enableSearch={true}
        enableDownload={true}
        enablePrint={true}
        onDocumentLoad={(info) => console.log("PDF loaded:", info)}
        onPageChange={(page) => console.log("Page changed:", page)}
        onZoomChange={(zoom) => console.log("Zoom changed:", zoom)}
        customToolbarButtons={[
          {
            label: "Custom",
            icon: "⚙️",
            title: "Custom Action",
            onClick: () => alert("Custom button clicked!"),
          },
        ]}
      />
    ),
    gridPosition: { x: 1, y: 0 },
    parentFolder: "29",
  },
  {
    id: "32",
    file_name: "Recommendation_Letter_3.pdf",
    file_type: "p",
    icon_source: PdfIcon,
    content: (
      <PDFViewer
        pdfUrl={recommendation_letter_3}
        fileName="Recommendation_Letter_3.pdf"
        theme="light"
        enableToolbar={true}
        enableSearch={true}
        enableDownload={true}
        enablePrint={true}
        onDocumentLoad={(info) => console.log("PDF loaded:", info)}
        onPageChange={(page) => console.log("Page changed:", page)}
        onZoomChange={(zoom) => console.log("Zoom changed:", zoom)}
        customToolbarButtons={[
          {
            label: "Custom",
            icon: "⚙️",
            title: "Custom Action",
            onClick: () => alert("Custom button clicked!"),
          },
        ]}
      />
    ),
    gridPosition: { x: 2, y: 0 },
    parentFolder: "29",
  },
  {
    id: "33",
    file_name: "UP_Inna.mp3",
    file_type: "m", // 'm' for music
    icon_source: MusicIcon,
    content: Music_1,
    gridPosition: { x: 0, y: 1 },
    parentFolder: null,
  },
  {
    id: "34",
    file_name: "Coolio_Gangster_s_Paradise.mp3",
    file_type: "m", // 'm' for music
    icon_source: MusicIcon,
    content: Music_2,
    gridPosition: { x: 1, y: 1 },
    parentFolder: null,
  },
  {
    id: "35",
    file_name: "challenge_1",
    file_type: "ctf",
    icon_source: CTFIcon,
    content: <SubmitCtf />,
    gridPosition: { x: 5, y: 1 },
    parentFolder: null,
  },
  {
    id: "36",
    file_name: "Morse_Code_Converter",
    file_type: "morse",
    icon_source: Morseicon,
    content: <MorseConverter />,
    gridPosition: { x: 7, y: 0 },
    parentFolder: null,
  },
  {
    id: "37",
    file_name: "My_LinkedIn",
    file_type: "linkedin",
    icon_source: LinkedIn,
    content: null,
    gridPosition: { x: 4, y: 0 },
    parentFolder: null,
  },
  {
    id: "38",
    file_name: "Calculator",
    file_type: "calc",
    icon_source: CalculatorIcon,
    content: <Calculator />,
    gridPosition: { x: 4, y: 1 },
    parentFolder: null,
  },
  {
    id: "39",
    file_name: "challenge_2",
    file_type: "ctf",
    icon_source: CTFIcon,
    content: <SubmitCtf_2 />,
    gridPosition: { x: 6, y: 1 },
    parentFolder: null,
  },
  {
    id: "40",
    file_name: "Icons",
    file_type: "d",
    icon_source: FolderIcon,
    content: null,
    gridPosition: { x: 2, y: 0 },
    parentFolder: "11",
  },
  {
    id: "41",
    file_name: "Readme.txt",
    file_type: "tf", //text file
    icon_source: FileIcon,
    content: (
      <TextFile content="In this folder, you can find and see all icons used in this portfolio website,\nthey are all designed and drawn from scratch by me.\n\n" />
    ),
    gridPosition: { x: 0, y: 0 },
    parentFolder: "40",
  },
  {
    id: "42",
    file_name: "PDF_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: PdfIcon_svg,
    alt: "PDF Icon",
    content: null,
    gridPosition: { x: 1, y: 0 },
    parentFolder: "40",
  },
  {
    id: "43",
    file_name: "File_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: FileIcon_svg,
    alt: "File Icon",
    content: null,
    gridPosition: { x: 2, y: 0 },
    parentFolder: "40",
  },
  {
    id: "44",
    file_name: "Browser_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: BrowserIcon_svg,
    alt: "Browser Icon",
    content: null,
    gridPosition: { x: 3, y: 0 },
    parentFolder: "40",
  },
  {
    id: "45",
    file_name: "Video_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: VideoIcon_svg,
    alt: "Video Icon",
    content: null,
    gridPosition: { x: 4, y: 0 },
    parentFolder: "40",
  },
  {
    id: "46",
    file_name: "Morse_Code_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: Morseicon_svg,
    alt: "Morse Code Icon",
    content: null,
    gridPosition: { x: 5, y: 0 },
    parentFolder: "40",
  },
  {
    id: "47",
    file_name: "Image_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: ImageIcon_svg,
    alt: "Image Icon",
    content: null,
    gridPosition: { x: 0, y: 1 },
    parentFolder: "40",
  },
  {
    id: "48",
    file_name: "Folder_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: FolderIcon_svg,
    alt: "Folder Icon",
    content: null,
    gridPosition: { x: 1, y: 1 },
    parentFolder: "40",
  },
  {
    id: "49",
    file_name: "Music_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: MusicIcon_svg,
    alt: "Music Icon",
    content: null,
    gridPosition: { x: 2, y: 1 },
    parentFolder: "40",
  },
  {
    id: "50",
    file_name: "CTF_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: CTFIcon_svg,
    alt: "CTF Icon",
    content: null,
    gridPosition: { x: 3, y: 1 },
    parentFolder: "40",
  },
  {
    id: "51",
    file_name: "Calculator_Icon",
    file_type: "i",
    icon_source: ImageIcon,
    src: CalculatorIcon_svg,
    alt: "Calculator Icon",
    content: null,
    gridPosition: { x: 4, y: 1 },
    parentFolder: "40",
  },
];
